<div (click)='selectMe()' (mouseenter)='focused()'  [class]='"option container " + ((FilterIncluded) ? "" : "hide") + ((hasFocus)?" focused":"")'>
    <p [class]='"option-content " + ((IsSelected) ? "selected" : "")' [id]='value' [style.margin-left.px]='10*indent + 10' #label>
        <ng-content></ng-content>
    </p>
</div>